import React, { useState } from 'react';
import FormSelector from './FormSelector';
import { FORM_COMPONENTS, BEAM_FORM_COMPONENTS } from '../Constants/Constants';
import { isBeamUser } from '../Utils/HelperFunctions';

const Dashboard = () => {
  const [selectedForm, setSelectedForm] = useState('');
  const components = isBeamUser() ? BEAM_FORM_COMPONENTS : FORM_COMPONENTS;

  return (
    <div className='csm-container'>
      <div className='box w-full'>
        <h1 className='my-5 text-center text-3xl font-semibold '>CSM-Dashboard</h1>
        <div style={{ textAlign: 'center' }}>
          <FormSelector onChange={setSelectedForm} />
          {components[selectedForm] ?? null}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
